import React from "react";
const icon = (
  <svg
    width="448"
    height="512"
    viewBox="0 0 448 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_54)">
      <path
        d="M349.4 44.6C355.3 30.9 350.9 14.9 338.8 6.1C326.7 -2.7 310.2 -1.9 298.9 7.9L42.9 231.9C32.9 240.7 29.3 254.8 34 267.2C38.7 279.6 50.7 288 64 288H175.5L98.6 467.4C92.7 481.1 97.1 497.1 109.2 505.9C121.3 514.7 137.8 513.9 149.1 504.1L405.1 280.1C415.1 271.3 418.7 257.2 414 244.8C409.3 232.4 397.4 224.1 384 224.1H272.5L349.4 44.6Z"
        fill="#8803E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_54">
        <rect width="448" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default icon;
